import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import Grid from '@mui/material/Grid';
import Star from '@mui/icons-material/Star';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import { OfferAssetImage, OfferCardContent } from './OfferListStyles';
import { ListEditIcon, ListEditLink } from 'components/common/CommonStyles';

const OfferListItem = ({ t, fieldsToShow, item, onEditLink, index }) => {
  return (
    <Card disablePadding>
      <OfferCardContent container spacing={1} colors={item}>
        <Grid item container xs={12} sm={4} lg={2} pr={2} alignItems='center'>
          {fieldsToShow.includes('assetImage') && item.defaultUrl && <OfferAssetImage src={item.defaultUrl} alt='asset_image' />}
        </Grid>
        <Grid item container spacing={1} xs={12} lg={fieldsToShow.includes('assetImage') ? 10 : 12}>
          {fieldsToShow.includes('offerNumber') && (
            <Grid item xs={12} md={4} sm={6} id={'offerList_offer_' + index + '_offerNumber'}>
              <strong> {t('OfferList.OfferNumber')}</strong>: <span>{item.offerNumber}</span>
            </Grid>
          )}
          {fieldsToShow.includes('clientName') && (
            <Grid item xs={12} md={4} sm={6} id={'offerList_offer_' + index + '_clientName'}>
              <strong> {t('OfferList.Client')}</strong>: <span>{item.clientName}</span>
            </Grid>
          )}
          {fieldsToShow.includes('financedAmount') && (
            <Grid item xs={12} md={4} sm={6} id={'offerList_offer_' + index + '_financedAmount'}>
              <strong> {t('OfferList.FinancedAmount')}</strong>:{' '}
              <span>
                {t('NUMBER', { number: item.financedAmount })} {item.currency}
              </span>
            </Grid>
          )}
          {fieldsToShow.includes('offerDate') && (
            <Grid item xs={12} md={4} sm={6} id={'offerList_offer_' + index + '_offerDate'}>
              <strong>{t('OfferList.OfferDate')}</strong>: <span>{t('DATE', { date: item.offerDate })}</span>
            </Grid>
          )}
          {fieldsToShow.includes('responsibleId') && (
            <Grid item xs={12} md={4} sm={6} id={'offerList_offer_' + index + '_responsible'}>
              <strong> {t('OfferList.Responsible')}</strong>:{' '}
              <span>
                {item.isReplacementOffer ? <Star /> : ''} {item.responsibleName}
              </span>
            </Grid>
          )}
          {fieldsToShow.includes('UserName') && (
            <Grid item xs={12} md={4} sm={6} id={'offerList_offer_' + index + '_user'}>
              <strong> {t('OfferList.User')}</strong>:{' '}
              <span>
                {item.isReplacementOffer ? <Star /> : ''} {item.userName}
              </span>
            </Grid>
          )}
          {fieldsToShow.includes('financialProductName') && (
            <Grid item xs={12} md={4} sm={6} id={'offerList_offer_' + index + '_financialProductName'}>
              <strong> {t('OfferList.FinancialProduct')}</strong>: <span>{item.financialProductName}</span>
            </Grid>
          )}
          {fieldsToShow.includes('salesChannel') && (
            <Grid item xs={12} md={4} sm={6} id={'offerList_offer_' + index + '_salesChannel'}>
              <strong> {t('OfferList.SalesChannel')}</strong>: <span>{item.channel}</span>
            </Grid>
          )}
          {fieldsToShow.includes('priority') && (
            <Grid item xs={12} md={4} sm={6} id={'offerList_offer_' + index + '_priority'}>
              <strong> {t('OfferList.Priority')}</strong>: <span>{item.priority}</span>
            </Grid>
          )}
          {fieldsToShow.includes('transactionCategory') && (
            <Grid item xs={12} md={4} sm={6} id={'offerList_offer_' + index + '_transactionCategory'}>
              <strong> {t('OfferList.TransactionCategory')}</strong>: <span>{item.transactionCategory}</span>
            </Grid>
          )}
          {fieldsToShow.includes('uniqueId') && (
            <Grid item xs={12} md={4} sm={6} id={'offerList_offer_' + index + '_uniqueId'}>
              <strong> {t('OfferList.UniqueId')}</strong>: <span>{item.clientCnpOrCui}</span>
            </Grid>
          )}
          {fieldsToShow.includes('sourceTypeId') && (
            <Grid item xs={12} md={4} sm={6} id={'offerList_offer_' + index + '_sourceType'}>
              <strong> {t('OfferList.Source')}</strong>: <span>{item.sourceTypeName}</span>
            </Grid>
          )}
          {fieldsToShow.includes('stateName') && (
            <Grid item xs={12} md={4} sm={6} id={'offerList_offer_' + index + '_stateName'}>
              <strong> {t('OfferList.State')}</strong>: <span>{item.stateName}</span>
            </Grid>
          )}
          {fieldsToShow.includes('contractTypeName') && (
            <Grid item xs={12} md={4} sm={6} id={'offerList_offer_' + index + '_contractTypeName'}>
              <strong> {t('OfferList.ContractType')}</strong>: <span>{item.contractTypeName}</span>
            </Grid>
          )}
          {fieldsToShow.includes('offerTypeName') && (
            <Grid item xs={12} md={4} sm={6} id={'offerList_offer_' + index + '_offerTypeName'}>
              <strong> {t('OfferList.OfferType')}</strong>: <span>{item.offerTypeName}</span>
            </Grid>
          )}
          {fieldsToShow.includes('workLocationName') && (
            <Grid item xs={12} md={4} sm={6} id={'offerList_offer_' + index + '_workLocationName'}>
              <strong> {t('OfferList.WorkLocation')}</strong>: <span>{item.workLocationName}</span>
            </Grid>
          )}
        </Grid>
        <ListEditLink to={onEditLink(item)}>
          <IconButton id='offerList_editBtn' size='small' color='primary' tooltip={t('Edit')}>
            <ListEditIcon />
          </IconButton>
        </ListEditLink>
      </OfferCardContent>
    </Card>
  );
};

OfferListItem.propTypes = {
  t: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  fieldsToShow: PropTypes.array.isRequired,
  onEditLink: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired
};

export default compose(withTranslation())(OfferListItem);
